import React, { useCallback, useState, useEffect } from "react";
import styles from "./CustomiseColumns.module.css";
import { styled } from "@mui/system";
import { Drawer, Box, TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from "@mui/material";
import SingleSelectWithInput from "../dropdown/SingleSelectWithInput";
import CustomButton from "../buttons/CustomButton";
import SnackBarMessage from "../snackbar/snackbar";
import { get_cbu_details, get_cascade_line_list, getTonsPerShift } from "../../api/DailyphaingAPIs";
import cross from './../../../assets/images/refresh-cw 1.svg';
import Plus from "./../../../assets/images/Plus.svg";
import TrashBtn from "./../../../assets/images/TrashBtn.svg";
import { isInputEnabled, isButtonEnabled } from "../../../utils/mmScreenInput";
import { useDailyPhasingContext } from "utils/dailyphaisngContext/DailyphasingContext";

export const StyledTableCell = styled(TableCell)((props) => ({
    "&.MuiTableCell-head": {
        fontFamily: "Unilever Shilling",
        color: "#fff",
        textAlign: "center",
        padding: "2px",
        fontSize: "11px",
        fontWeight: 600,
        outline: "1px solid #EAECF0",
        whiteSpace: "nowrap",
    },
    "&.MuiTableCell-body": {
        fontFamily: "Unilever Shilling",
        fontSize: "11px",
        fontWeight: 400,
        padding: "2px",
        color: "#2B2B2B",
        border: "1px solid #DBDBDB !important",
        textAlign: "center",

        whiteSpace: "nowrap",
    }
}));

const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

const infoTableColumns = [
    { label: "Format", key: "Format" },
    { label: "Basepack", key: "Basepack" },
    { label: "CBU description", key: "CBU description" }
];

const columns = [
    {
        label: "Site code", key: "Site code",
        input: false, dropdown: true, width: "150px"
    },
    {
        label: "Cascade", key: "Cascade",
        input: false, dropdown: true, width: "150px"
    },
    {
        label: "Line", key: "Line",
        input: false, dropdown: true, width: "150px"
    },
    {
        label: "Priority", key: "Priority",
        input: false, dropdown: true, width: "100px"
    },
    {
        label: "Mon", key: "Mon",
        input: true, dropdown: false, width: "30px"
    },
    {
        label: "Tue", key: "Tue",
        input: true, dropdown: false, width: "30px"
    },
    {
        label: "Wed", key: "Wed",
        input: true, dropdown: false, width: "30px"
    },
    {
        label: "Thu", key: "Thu",
        input: true, dropdown: false, width: "30px"
    },
    {
        label: "Fri", key: "Fri",
        input: true, dropdown: false, width: "30px"
    },
    {
        label: "Sat", key: "Sat",
        input: true, dropdown: false, width: "30px"
    },
    {
        label: "Sun", key: "Sun",
        input: true, dropdown: false, width: "30px"
    },
    {
        label: "Total", key: "Total",
        input: false, dropdown: false, width: ""
    },
    {
        label: "Action", key: "Action",
        input: false, dropdown: false, width: ""
    }

]

const priority = ["Prio 1", "Prio 2", "Prio 3"];

const createInitialData = () => ({
    "Site code": "", "Site cluster": "", "SAP weekly plan": 0,
    Cascade: "", CascadeOptions: [], isCascadeDisabled: true,
    Line: "", LineOptions: [], isLineDisabled: true,
    Mon: 0, Tue: 0, Wed: 0, Thu: 0, Fri: 0, Sat: 0, Sun: 0, Total: 0,
    Priority: "Prio 1",
    isUpdated: false, created: new Date().toISOString()
});


const AddNewCBU = ({ anchor, drawerIsOpen, currentData, filteredData, dataFields = [], onAddDataHandler, drawerToggleHandler }) => {
    const [loader, setLoader] = useState(false);
    const [list, setList] = useState([]);
    const [addLoader, setaddLoader] = useState(false);
    const [cbu, setCbu] = useState("");
    const [infoData, setInfoData] = useState([]);
    const [tblRows, setTblRows] = useState([]);
    const [sideCods, setSiteCodes] = useState({ 'Site code': [], 'Format': [] });
    const [existRows, setExistRow] = useState([]);
    const [snackBarObject, setSnackBarObject] = useState({
        snackbarOpen: false,
        message: ' ',
        type: 'error'
    });
    const { idToken } = useDailyPhasingContext();

    const closeDrawer = useCallback(() => drawerToggleHandler(), [drawerToggleHandler]);
    const closeSnackbar = useCallback(() => {
        setSnackBarObject({ message: '', snackbarOpen: false, type: 'error' });
    }, []);
    const openSnackbar = useCallback((msg) => {
        setSnackBarObject({ message: msg, snackbarOpen: true, type: 'error' });
    }, []);

    const getCBUDetails = useCallback(async () => {
        setLoader(true);
        try {
            let sideCods = []
            if (!cbu) {
                throw new Error("Please enter CBU code");
            }

            const { cbu_details } = await get_cbu_details({ cbu: cbu });
            const { cascade_line } = await get_cascade_line_list(idToken);
            if (!cbu_details || !cbu_details.length) {
                throw new Error("No data found for the given CBU code");
            }

            if (!cascade_line || !cascade_line) {
                openSnackbar("Cascade and Line records are currently unavailable.")
            }
            let formatList = [];
            for (const i in filteredData) {
                if (filteredData[i].label === "Site code") {
                    if (filteredData[i].selectedData.length) {
                        sideCods = [...filteredData[i].selectedData]
                    } else {
                        sideCods = [...filteredData[i].data]
                    }
                }
                if (filteredData[i].label === "Format") {
                    if (filteredData[i].selectedData.length) {
                        formatList = [...filteredData[i].selectedData];
                    }
                }
            }
            setSiteCodes({'Site code' : sideCods, 'Format': formatList});
            setInfoData(cbu_details);
            setList(cascade_line)
            if (tblRows.length) {
                setTblRows([createInitialData()]);
            }
        } catch (error) {
            openSnackbar(error.message);
        } finally {
            setLoader(false);
        }
    }, [cbu, tblRows, filteredData, openSnackbar])


    const getRowTotal = useCallback((row) => (
        WEEKDAYS.reduce((sum, day) => sum + (Number(row[day]) || 0), 0)
    ), []);

    const onChangeHandler = useCallback((label, value, rid) => {
        if (label === "Site code") {
            let row = [];
            
            // Filter based on Site code and Format (if Format filter is applied)
            if (list.length) {
                row = list.filter(item => {
                    if (sideCods["Format"].length) {
                        return item["Site code"] === value && sideCods["Format"].some(format => {
                            return format.toLowerCase() === item["Format"].toLowerCase();
                        });
                    }
                    return item["Site code"] === value;
                });
            }
            
            const cascades = row.length ? Array.from(new Set(row.map(item => item["Cascade"]))) : [];
            const lines = row.length ? Array.from(new Set(row.map(item => item["Line"]))) : [];

            const siteCluster = currentData.find((item) => item["Site code"] === value)?.["Site cluster"] || '';
            const sapWeeklyPlan = currentData.find((item) => item["CBU code"] === cbu && item["Site code"] === value)?.["SAP weekly plan"] || 0

            setTblRows((prev) => {
                const updatedRows = [...prev];
                updatedRows[rid][label] = value;
                updatedRows[rid]["Cascade"] = "";
                updatedRows[rid]["Line"] = "";
                updatedRows[rid]["Site cluster"] = siteCluster;
                updatedRows[rid]["SAP weekly plan"] = sapWeeklyPlan;
                updatedRows[rid]["CascadeOptions"] = [...cascades];
                updatedRows[rid]["LineOptions"] = [...lines];
                updatedRows[rid]["isCascadeDisabled"] = false;
                updatedRows[rid]["isLineDisabled"] = false;
                return updatedRows;
            });
        } else if (label === "Cascade") {
            // When Cascade changes, filter Lines based on selected Cascade
            setTblRows((prev) => {
                const updatedRows = [...prev];
                const currentRow = updatedRows[rid];
                const siteCode = currentRow["Site code"];
                
                // Filter lines for this Cascade and Site code
                const filteredLines = list
                    .filter(item => {
                        const formatMatch = sideCods["Format"].length 
                            ? sideCods["Format"].some(format => format.toLowerCase() === item["Format"].toLowerCase())
                            : true;
                        return item["Site code"] === siteCode && 
                               item["Cascade"] === value && 
                               formatMatch;
                    })
                    .map(item => item["Line"]);
                
                const uniqueLines = Array.from(new Set(filteredLines));
                
                updatedRows[rid][label] = value;
                updatedRows[rid]["LineOptions"] = uniqueLines;
                
                // Auto-select Line if only one option
                if (uniqueLines.length === 1) {
                    updatedRows[rid]["Line"] = uniqueLines[0];
                    updatedRows[rid].isUpdated = true;
                } else {
                    updatedRows[rid]["Line"] = "";
                }
                
                return updatedRows;
            });
        } else if (label === "Line") {
            // When Line changes, filter Cascade (should be only one) and auto-select it
            setTblRows((prev) => {
                const updatedRows = [...prev];
                const currentRow = updatedRows[rid];
                const siteCode = currentRow["Site code"];
                
                // Filter cascades for this Line and Site code
                const filteredCascades = list
                    .filter(item => {
                        const formatMatch = sideCods["Format"].length 
                            ? sideCods["Format"].some(format => format.toLowerCase() === item["Format"].toLowerCase())
                            : true;
                        return item["Site code"] === siteCode && 
                               item["Line"] === value && 
                               formatMatch;
                    })
                    .map(item => item["Cascade"]);
                
                const uniqueCascades = Array.from(new Set(filteredCascades));
                
                updatedRows[rid][label] = value;
                updatedRows[rid]["CascadeOptions"] = uniqueCascades;
                
                // Auto-select Cascade (each Line has only one Cascade)
                if (uniqueCascades.length === 1) {
                    updatedRows[rid]["Cascade"] = uniqueCascades[0];
                }
                
                updatedRows[rid].isUpdated = true;
                return updatedRows;
            });
        } else {
            setTblRows((prev) => {
                const updatedRows = [...prev];
                updatedRows[rid][label] = value;
                return updatedRows;
            });
        }
    }, [currentData, cbu, list, sideCods])


    const addRowHandler = useCallback(() => {
        setTblRows((prev) => [...prev, createInitialData()]);
    }, [])

    const deleteRowHandler = useCallback((created) => {
        const tblArray = [...tblRows];
        const extArray = [...existRows];

        const tblArrayIndex = tblArray.findIndex(row => row.created === created);
        if (tblArrayIndex !== -1) {
            tblArray.splice(tblArrayIndex, 1);
            setTblRows(tblArray);
        }

        const extArrayIndex = extArray.indexOf(created);
        if (extArrayIndex !== -1) {
            extArray.splice(extArrayIndex, 1);
            setExistRow(extArray);
        }

    }, [tblRows, existRows])

    
    const mapPriorityForNewRows = useCallback((filterData) => {
        const priorityMap = {}; // To track priorities for new row combinations
        const timestamp = Date.now();
        const cbuDetails = infoData[0] || {};
        return filterData.map((row, i) => {
            const newRow = { ...row };
            const combinationKey = `${cbu}_${newRow["Site code"]}`;
            
            // Scenario 1: Check if combination exists in existing data (currentData)
            const existingEntry = currentData.find(item => 
                item["CBU code"] === cbu && 
                item["Site code"] === newRow["Site code"]
            );

            let finalPriority;
            if (existingEntry && existingEntry["Priority"]) {
                // Scenario 1: Map to existing entry's priority
                finalPriority = existingEntry["Priority"];
            } else if (priorityMap[combinationKey]) {
                // Scenario 3: Map to first new row's priority with same combination
                finalPriority = priorityMap[combinationKey];
            } else {
                // Scenario 2: Use user-entered priority and store it for future rows
                finalPriority = newRow["Priority"];
                priorityMap[combinationKey] = finalPriority;
            }

            newRow["Priority"] = finalPriority;

            newRow["constValues"] = {
                Cascade: newRow["Cascade"],
                Line: newRow["Line"],
                Mon: newRow["Mon"],
                Tue: newRow["Tue"],
                Wed: newRow["Wed"],
                Thu: newRow["Thu"],
                Fri: newRow["Fri"],
                Sat: newRow["Sat"],
                Sun: newRow["Sun"],
                "Reason for change": ""
            };
            
            WEEKDAYS.forEach(key => {
                newRow[key] = Number(newRow[key]);
                newRow["constValues"][key] = Number(newRow[key]);
            });

            newRow["SAP weekly plan"] = currentData.length ? currentData.find(item => item["CBU code"] === cbu && item["Site code"] === newRow["Site code"])?.["SAP weekly plan"] || 0 : 0;
            
            return {
                ...newRow,
                id: `NEW_${timestamp}_${i}`,
                PreCascade: newRow["Cascade"],
                PreLine: newRow["Line"],
                "Reason for change": "",
                IsAddNewCBU: true,
                IsDraft: false,
                Total: getRowTotal(newRow),
                Flag: currentData?.[0]?.Flag || "",
                isAdded: true, 
                isUpdated: false,
                Week: currentData?.[0]?.Week || "",
                Format: sideCods["Format"].length === 1 ? sideCods["Format"][0] : cbuDetails["Format"] || "",
                isSubmitted: false,
                BG: cbuDetails["BG"] || "",
                Segmentation: cbuDetails["Segmentation"] || "",
                Format: cbuDetails["Format"] || "",
                Basepack: cbuDetails["Basepack"] || "",
                ABCD: cbuDetails["ABCD"] || "",
                Brand: cbuDetails["Brand"] || "",
                Subformat: cbuDetails["Subformat"] || ""
            };
        });
    }, [cbu, currentData, sideCods, getRowTotal]);


    const addNewRowHandler = useCallback(async () => {
        setaddLoader(true);
        try {
            if (!dataFields.length) throw new Error("Data Fields are missing");
            if (!cbu) throw new Error("No CBU Code found..");

            const obj = dataFields.reduce((acc, col) => {
                acc[col] = infoData[0].hasOwnProperty(col) ? infoData[0][col]
                    : col === "constValues" ? {}
                        : col === "CBU code" ? cbu : "";
                return acc;
            }, {});

            const filterData = tblRows.filter(item => item.isUpdated);
            if (!filterData.length) throw new Error("There are no data to submit");

            // Map priorities and prepare new rows
            const newRows = mapPriorityForNewRows(filterData).map(row => ({
                ...obj,
                ...row
            }));

            let exRows = [];
            for (const row of newRows) {
                // checking is there any rows are duplicates or not
                if (currentData.some(dt =>
                    row["CBU code"] === dt["CBU code"] &&
                    row["Site code"] === dt["Site code"] &&
                    row["Format"] === infoData[0]["Format"] &&
                    row["Cascade"] === dt["Cascade"] &&
                    row["Line"] === dt["Line"]
                )) {
                    exRows.push(row.created);
                }
            }

            if (exRows.length) {
                setExistRow(exRows);
                throw new Error("Some rows are already highlighted. Please delete them before adding.");
            }

            const finalData = newRows.map((row) => {
                delete row.CascadeOptions;
                delete row.LineOptions;
                // delete row.FormatOptions;
                delete row.isCascadeDisabled;
                delete row.isLineDisabled;
                delete row.isSiteCodeDisabled;
                delete row.created;
                row["Status"] = "Addition of a new row";
                return row;
            })
            const {data} = await getTonsPerShift(finalData);
            onAddDataHandler(data);
            closeDrawer();
        } catch (error) {
            openSnackbar(error.message);
        } finally {
            setaddLoader(false)
        }
    }, [dataFields, cbu, infoData, tblRows, openSnackbar, currentData, closeDrawer, onAddDataHandler, mapPriorityForNewRows])

    useEffect(() => {
        setTblRows([createInitialData()]);
    }, [])

    const disabled = isButtonEnabled();

    return (
        <div className={styles.drawerContainer}>
            <Drawer
                anchor={anchor}
                open={drawerIsOpen}
                sx={{ '& .MuiDrawer-paper': { width: "60vw" } }}
            >
                <div className={styles.heading}>
                    <span>Add new CBU</span>
                    <img src={cross} className={styles.closeIcon} onClick={closeDrawer} alt="Close drawer" />
                </div>
                <Box className={styles.addNewCBUContainer}>
                    <div className={styles.searchContainer}>
                        <input
                            className={styles.searchInput}
                            placeholder="CBU Code"
                            value={cbu}
                            onChange={(e) => setCbu(e.target.value.toUpperCase())}
                        />
                        <CustomButton label={loader ? "Get details..." : "Get details"} type="mm-submit" onClick={getCBUDetails} disabled={loader || addLoader} />
                    </div>
                    <TableContainer sx={{ margin: "10px 0" }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    {infoTableColumns.map((column) => (
                                        <StyledTableCell
                                            key={column.key}
                                            sx={{ backgroundColor: "var(--primany-table-header-color)" }}
                                        >{column.label}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {infoData.length ? infoData.map((row, rowId) => (
                                    <TableRow key={rowId}>
                                        {infoTableColumns.map((col, colId) => (
                                            <StyledTableCell key={`${rowId}${colId}`}>{row[col.label]}</StyledTableCell>
                                        ))}
                                    </TableRow>
                                )) : (
                                    <TableRow>
                                        <StyledTableCell></StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <div className={styles.addMoreBtnContainer}>
                        <CustomButton icon={Plus} label="Add more" type="mm-save" disabled={loader || addLoader} onClick={addRowHandler} />
                    </div>
                    <TableContainer sx={{ margin: "10px 0", height: "55vh" }}>
                        <Table size="small">
                            <TableHead sx={{ position: 'sticky', top: 0, zIndex: 999 }}>
                                <TableRow>
                                    {columns.map((column) => (
                                        <StyledTableCell
                                            key={column.key}
                                            sx={{ backgroundColor: "var(--primany-table-header-color)" }}
                                        >{column.label}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tblRows.length > 0 && tblRows.map((row, rid) => (
                                    <TableRow key={`row${rid}`} style={{ backgroundColor: existRows.includes(row.created) && "#ffe6e6" }}>
                                        {columns.map((col) => (
                                            col.input ? (
                                                <StyledTableCell key={`${col.key}${rid}`}>
                                                    <input
                                                        type="number"
                                                        key={`input-${col.label}${rid}`}
                                                        className={styles.tblInput}
                                                        style={{ width: col.width }}
                                                        value={row[col.label]}
                                                        // disabled={isInputEnabled(col.label)}
                                                        onWheel={(e) => e.target.blur()}
                                                        onKeyDown={(e) => e.key === 'e' && e.preventDefault()}
                                                        onChange={(e) => onChangeHandler(col.label, e.target.value, rid)}
                                                    />
                                                </StyledTableCell>

                                            ) : col.dropdown ? (
                                                <StyledTableCell key={`${col.key}${rid}`}>
                                                    <SingleSelectWithInput
                                                        key={`select-${col.label}${rid}`}
                                                        placeholder={col.label}
                                                        width={col.width}
                                                        label={col.label}
                                                        value={row[col.label]}
                                                        // disabled={isInputEnabled(col.label)}
                                                        options={col.label === "Site code" ? sideCods["Site code"]
                                                            : col.label === "Cascade" ? row.CascadeOptions
                                                                : col.label === "Line" ? row.LineOptions
                                                                    : col.label === "Priority" ? priority
                                                                : []}
                                                        onChangeHandler={(label, value) => onChangeHandler(label, value, rid)}
                                                    />
                                                </StyledTableCell>

                                            ) : col.label === "Total" ? (
                                                <StyledTableCell key={`${col.key}${rid}`}>{getRowTotal(row)}</StyledTableCell>
                                            ) : col.label === "Action" && (
                                                <StyledTableCell key={`${col.key}${rid}`}>
                                                    <span style={{ cursor: "pointer" }} onClick={() => deleteRowHandler(row.created)}>
                                                        <img src={TrashBtn} alt=".." />
                                                    </span>
                                                </StyledTableCell>
                                            )
                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
                <div className={styles.drawerBtns}>
                    <CustomButton label="Cancel" type="mm-save" onClick={closeDrawer} disabled={loader || addLoader || !disabled} />
                    <CustomButton label={addLoader ? "Adding..." : "Add"} type="mm-submit" onClick={addNewRowHandler} disabled={loader || addLoader || !disabled} />
                </div>

            </Drawer>
            {snackBarObject["snackbarOpen"] && (
                <SnackBarMessage
                    type={snackBarObject["type"]}
                    snackbarMessage={snackBarObject["message"]}
                    snackbarOpen={snackBarObject["snackbarOpen"]}
                    setSnackbarOpen={closeSnackbar}
                />
            )}
        </div>
    )
}

export default AddNewCBU;